var _path, _path2, _circle, _circle2, _circle3, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgImgEmptyCouponset = function SvgImgEmptyCouponset(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 31h-.8a.8.8 0 0 0 .8.8V31Zm0 18v-.8a.8.8 0 0 0-.8.8H5Zm.8-30A2.2 2.2 0 0 1 8 16.8v-1.6A3.8 3.8 0 0 0 4.2 19h1.6Zm0 12V19H4.2v12h1.6Zm-.8.8a8.2 8.2 0 0 1 8.2 8.2h1.6c0-5.412-4.388-9.8-9.8-9.8v1.6Zm8.2 8.2A8.2 8.2 0 0 1 5 48.2v1.6c5.412 0 9.8-4.388 9.8-9.8h-1.6ZM5.8 61V49H4.2v12h1.6ZM8 63.2A2.2 2.2 0 0 1 5.8 61H4.2A3.8 3.8 0 0 0 8 64.8v-1.6Zm64 0H8v1.6h64v-1.6Zm2.2-2.2a2.2 2.2 0 0 1-2.2 2.2v1.6a3.8 3.8 0 0 0 3.8-3.8h-1.6Zm0-42v42h1.6V19h-1.6ZM72 16.8a2.2 2.2 0 0 1 2.2 2.2h1.6a3.8 3.8 0 0 0-3.8-3.8v1.6Zm-64 0h64v-1.6H8v1.6Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BDBDBD",
    strokeWidth: 0.8,
    strokeDasharray: "3 3",
    d: "M25.4 16v48"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 40,
    r: 16,
    fill: "#BDBDBD",
    fillOpacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.087,
    cy: 36.087,
    r: 3.087,
    stroke: "#BDBDBD",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.348,
    cy: 43.804,
    r: 3.087,
    stroke: "#BDBDBD",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BDBDBD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M56.544 34.479 45.675 45.348"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImgEmptyCouponset);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/img-empty-couponset.5980a77051efb11286ea239bc0110016.svg";